// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading-module--heading--1mQj3"};